import { HttpEventType } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import moment from 'moment';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom, Subscription } from 'rxjs';
import { TypeDocumentEnums } from 'src/app/enum/type-document-enums';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { EquipmentLogbookImportModel } from 'src/app/models/imports/equipment-logbook-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { EquipmentLogbookService } from 'src/app/services/archive/equipment-logbook.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-equipment-logbook',
  templateUrl: './import-equipment-logbook.component.html',
  styleUrls: ['./import-equipment-logbook.component.scss'],
  standalone: false
})
export class ImportEquipmentLogbookComponent implements OnInit {

  private readonly equipmentLogbookService = inject(EquipmentLogbookService);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly ref = inject(DynamicDialogRef, { optional: true });

  equipmentLogbookAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  equipmentLogbookImport: boolean = false;
  eventFile: any;
  errorEquipmentLogbook: number = 0;
  loadEquipmentLogbookModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  suscription: Subscription;
  visibleTxt: boolean = false;

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  attachFileImport() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.equipmentLogbookImport) {
      data.params = { reload: true };
      this.ref?.close(data);
    } else {
      data.params = { reload: false };
      this.ref?.close(data);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  downloadGuideImport() {
    this.equipmentLogbookService.downloadGuideImport().subscribe(data => {
      if (data.type === HttpEventType.Response) {
        const downloadedFile = new Blob([data.body!], { type: data.body!.type });
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = "GuiaHojasDeVida.docx";
        a.href = URL.createObjectURL(downloadedFile);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.equipmentLogbookAlerts || this.equipmentLogbookAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.equipmentLogbookService.exportImportErrors(this.equipmentLogbookAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];
        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionHojasDeVida_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  importEquipmentLogbooks() {
    this.equipmentLogbookAlerts = [];
    this.errorEquipmentLogbook = 0;
    this.visibleTxt = false;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<EquipmentLogbookImportModel>();
    let row: EquipmentLogbookImportModel;
    let counter: number = 1;

    let articleCode: number, consecutive: number, typeDocumentId: number,
      providerDocument: string, invoiceNumber: string | null, purchaseDate: Date,
      purchaseValue: number, trademark: string | null, commercialName: string,
      reference: string, serie: string, yearManufacture: number | null,
      warrantyInitialDate: Date | null, warrantyFinalDate: Date | null, equipmentType: string | null,
      voltage: string | null, power: string | null, amperage: string | null, capacity: string | null,
      engineType: string | null, engineCode: string | null, trademarkEngine: string | null,
      referenceEngine: string | null, serieEngine: string | null, observation: string | null,
      unitCode: string | null, maintenanceFrequency: number | null, tolerance: number | null;

    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }

    readXlsxFile(input.files[0]).then(async (rows) => {
      this.equipmentLogbookAlerts = [];
      this.visibleTxt = false;
      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'error',
          'El archivo ingresado no tiene registros para importar.'
        );
        return;
      }

      rows.splice(0, 1);
      rows.forEach(element => {
        counter++;
        let rowHasError = false;

        // A. Consecutivo
        consecutive = element[0] as number;
        if (consecutive == null || isNaN(consecutive)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna A. El consecutivo no es válido.`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // B. Código Artículo
        articleCode = parseFloat(element[1] as string);
        if (isNaN(articleCode)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El código del artículo no es válido.`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        //C. Tipo de Documento:
        if (element[2] as string != "N" && element[2] as string != "C" && element[2] as string != "E") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. El tipo de documento debe ser valores como: 'N' / 'C' / 'E'.`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }
        switch (element[2] as string) {
          case "N": {
            typeDocumentId = TypeDocumentEnums.nit;
            break;
          }
          case "C": {
            typeDocumentId = TypeDocumentEnums.cedula;
            break;
          }
          default: {
            typeDocumentId = TypeDocumentEnums.extranjeria;
            break;
          }
        }

        // D. Documento Proveedor
        providerDocument = element[3] as string;
        if (!providerDocument) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. El documento del proveedor no es válido.`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        } else if (providerDocument.length > 15) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. El documento del proveedor supera el máximo de caracteres (15).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // E. Número Factura
        invoiceNumber = element[4] as string;
        if (invoiceNumber != null && invoiceNumber.length > 50) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna E. El número de factura supera el máximo de caracteres (50).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // F. Fecha Compra
        const purchaseDateString = element[5] as string;
        if (purchaseDateString == null || purchaseDateString == "") {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. El campo de fecha compra es obligatorio.`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }
        //Convierte fecha de string a Date
        purchaseDate = moment(purchaseDateString, 'DD/MM/YYYY').toDate();
        if (!moment(purchaseDateString, 'DD/MM/YYYY').isValid()) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. El campo de fecha compra no es válido.`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // G. Valor Compra
        purchaseValue = parseFloat(element[6] as string);
        if (isNaN(purchaseValue)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna G. El valor de compra no es válido.`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // H. Marca
        trademark = element[7] as string;
        if (trademark != null && trademark.length > 50) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna H. La marca supera el máximo de caracteres (50).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // I. Denominación Comercial
        commercialName = element[8] as string;
        if (commercialName == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna I. El nombre comercial no es válido.`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        } else if (commercialName.length > 50) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna I. El nombre comercial supera el máximo de caracteres (50).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // J. Referencia
        reference = element[9] as string;
        if (reference == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna J. La referencia no es válida.`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        } else if (reference.length > 50) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna J. La referencia supera el máximo de caracteres (50).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // K. Serie
        serie = element[10] as string;
        if (serie == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna K. La serie no es válida`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        } else if (serie.length > 50) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna K. La serie supera el máximo de caracteres (50).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // L. Año Fabricación
        if (element[11] as string != null) {
          yearManufacture = parseFloat(element[11] as string);
          if (yearManufacture != null && yearManufacture.toString().length > 4) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna L. El año de fabricación no es válido.`;
            this.equipmentLogbookAlerts.push(alert);
            rowHasError = true;
          }
        } else {
          yearManufacture = null;
        }

        // M. Fecha Inicio Garantía
        const warrantyInitialDateString = element[12] as string;
        if (warrantyInitialDateString != null) {
          //Convierte fecha de string a Date
          warrantyInitialDate = moment(warrantyInitialDateString, 'DD/MM/YYYY').toDate();
          if (!moment(warrantyInitialDateString, 'DD/MM/YYYY').isValid()) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna M. El campo de fecha inicio garantía no es válido.`;
            this.equipmentLogbookAlerts.push(alert);
            rowHasError = true;
          }
        }

        // N. Fecha Fin Garantía
        const warrantyFinalDateString = element[13] as string;
        if (warrantyFinalDateString != null) {
          //Convierte fecha de string a Date
          warrantyFinalDate = moment(warrantyFinalDateString, 'DD/MM/YYYY').toDate();
          if (!moment(warrantyFinalDateString, 'DD/MM/YYYY').isValid()) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna N. El campo de fecha fin garantía no es válido.`;
            this.equipmentLogbookAlerts.push(alert);
            rowHasError = true;
          }
        }

        // O. Tipo Equipo
        equipmentType = element[14] as string;
        if (equipmentType != null && equipmentType.length > 50) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna O. El tipo de equipo supera el máximo de caracteres (50).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // P. Voltaje
        voltage = element[15] as string;
        if (voltage != null && voltage.length > 20) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna P. El voltaje supera el máximo de caracteres (20).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // Q. Potencia
        power = element[16] as string;
        if (power != null && power.length > 20) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna Q. La potencia supera el máximo de caracteres (20).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // R. Amperaje
        amperage = element[17] as string;
        if (amperage != null && amperage.length > 20) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna R. El amperaje supera el máximo de caracteres (20).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // S. Capacidad
        capacity = element[18] as string;
        if (capacity != null && capacity.length > 20) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna S. La capacidad supera el máximo de caracteres (20).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // T. Tipo Motor
        engineType = element[19] as string;
        if (engineType != null && engineType.length > 50) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna T. El tipo de motor supera el máximo de caracteres (50).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // U. Código Motor
        engineCode = element[20] as string;
        if (engineCode != null && engineCode.length > 20) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna U. El código del motor supera el máximo de caracteres (20).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // V. Marca Motor
        trademarkEngine = element[21] as string;
        if (trademarkEngine != null && trademarkEngine.length > 50) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna V. La marca del motor supera el máximo de caracteres (50).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // W. Referencia Motor
        referenceEngine = element[22] as string;
        if (referenceEngine != null && referenceEngine.length > 50) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna W. La referencia del motor supera el máximo de caracteres (50).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // X. Serie Motor
        serieEngine = element[23] as string;
        if (serieEngine != null && serieEngine.length > 50) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna X. La serie del motor supera el máximo de caracteres (50).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        // Y. Observación
        observation = element[24] as string;
        if (observation != null && observation.length > 500) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna Y. La observación supera el máximo de caracteres (500).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        //Z. Variable de medición
        unitCode = element[25] as string;
        if (unitCode != null && unitCode.length > 4) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna Z. La variable de medición supera el máximo de caracteres (4).`;
          this.equipmentLogbookAlerts.push(alert);
          rowHasError = true;
        }

        //AA. Frecuencia de mantenimiento
        maintenanceFrequency = element[26] as number;

        //AB. Tolerancia
        tolerance = element[27] as number;

        if (!rowHasError) {
          row = new EquipmentLogbookImportModel(
            counter, articleCode, consecutive, typeDocumentId, providerDocument,
            invoiceNumber, purchaseDate, purchaseValue, trademark, commercialName,
            reference, serie, yearManufacture, warrantyInitialDate, warrantyFinalDate,
            equipmentType, voltage, power, amperage, capacity, engineType,
            engineCode, trademarkEngine, referenceEngine, serieEngine, observation,
            unitCode, maintenanceFrequency, tolerance
          );
          rowsImports.push(row);
        } else {
          isOk = false;
        }
      });

      if (!isOk || rowsImports.length === 0) {
        this.errorEquipmentLogbook = 1;
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
        this.clearInputFile();
        return;
      }

      await this.processImportEquipmentLogbooks(rowsImports);
    });
  }

  async processImportEquipmentLogbooks(rowsImports: Array<EquipmentLogbookImportModel>) {
    try {
      const response = await firstValueFrom(this.equipmentLogbookService.importEquipmentLogbooks(rowsImports));
      this.loadEquipmentLogbookModel = response;
      this.equipmentLogbookAlerts = response?.alerts ?? [];
      this.errorEquipmentLogbook = response?.preInvoicingStateId;
      if (this.errorEquipmentLogbook === 1) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
      } else if (this.equipmentLogbookAlerts.length > 0) {
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con alertas, puede exportarlas si lo desea'
        );
      } else {
        this.visibleTxt = false;
        this.equipmentLogbookImport = true;
        this.toastHandlerService.showToast(
          'success',
          `La importación terminó exitosamente.`
        );
        this.close();
      }
      this.clearInputFile();
    } catch (error) {
      this.nameFile = 'Ningún archivo seleccionado.';
      console.error('Error al importar hojas de vida de equipos.', error);
    }
  }
}
